<template>
	<div class="app">
		<!-- 固定头部 -->
		<div class="header" v-show="!isMobile || (!cookiesOpen && !formOpen)">
			<headerCont ref="headerCont" @navToLink="navToLink" :isMobile="isMobile"></headerCont>
		</div>
		<!-- 内容区域 -->
		<div class="content" v-show="!isMobile || (!cookiesOpen && !formOpen)" @click="closeHeaderMobileMenu">
			<keep-alive>
				<router-view />
			</keep-alive>
			<pcCookies v-if="!isMobile && cookiesTipsOpen && isShowMobileOfficialWebsiteAlert"></pcCookies>
			<cookiesTips v-if="isMobile && cookiesTipsOpen && isShowMobileOfficialWebsiteAlert" @openCookies="openCookies" @closeTips="closeTips"></cookiesTips>
			<formPc v-if="!isMobile && formOpen"></formPc>
			<officialWebsiteAlert v-if="isShowOfficialWebsiteAlert"></officialWebsiteAlert>
		</div>
		<!-- 固定底部 -->
		<div class="bottom" v-show="!isMobile || (!cookiesOpen && !formOpen)">
			<bottomContMobile v-if="isMobile" :title="title" />
			<bottomCont v-else />
		</div>
		<!-- 移动端cookies -->
		<cookies v-if="isMobile && cookiesOpen" @close="close"></cookies>
		<!-- 移动端表单 -->
		<formMobile v-if="isMobile && formOpen"></formMobile>

	</div>
</template>

<script>
import headerCont from './components/headerCont'
import bottomCont from './components/bottomCont'
import bottomContMobile from './components/bottomContMobile';
import pcCookies from './page/pc/cookies.vue'
import formMobile from './page/mobile/form.vue';
import formPc from './page/pc/form.vue';
import cookies from './page/mobile/cookies.vue';
import cookiesTips from './page/mobile/cookiesTips.vue';
import officialWebsiteAlert from './components/officialWebsiteAlert.vue'
import { bus } from './utils/bus';
export default {
	name: 'KOMO',
	components: {
		headerCont,
		bottomCont,
		bottomContMobile,
		pcCookies,
		formMobile,
		cookies,
		cookiesTips,
		formPc,
		officialWebsiteAlert
	},
	data() {
		return {
			isMobile: false,   // 默认先给 false，避免闪烁
			title: '', //接受顶部路由跳转时回传的标题
			cookiesOpen: false,
			cookiesTipsOpen: true,
			formOpen: false
		}
	},
	computed: {
		isShowOfficialWebsiteAlert() {
			const storedTimestamp = localStorage.getItem('alertClosedTimestamp');
			if (!storedTimestamp) return true;
			
			const threeDaysInMs = 3 * 24 * 60 * 60 * 1000; // 3天的毫秒数
			const currentTimestamp = new Date().getTime();
			const timeDiff = currentTimestamp - parseInt(storedTimestamp);
			
			return timeDiff > threeDaysInMs;
		},
		isShowMobileOfficialWebsiteAlert() {
			const storedTimestamp = localStorage.getItem('isShowMobileOfficialWebsiteAlert');
			if (!storedTimestamp) return true;
			
			const threeDaysInMs = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒数
			const currentTimestamp = new Date().getTime();
			const timeDiff = currentTimestamp - parseInt(storedTimestamp);
			
			return timeDiff > threeDaysInMs;
		},
	},
	mounted () {
		this.isMobile = this.checkMobile()
		console.log(this.isMobile)
		if (!this.isMobile) {
			window.addEventListener('resize', this.handleResize);
		}
	},
	methods: {
		// 在某些情况下关闭移动端菜单
		closeHeaderMobileMenu () {
			console.log('11111111111111111')
			if (this.$refs.headerCont && this.$refs.headerCont.isMobileMenuOpen) {
				this.$refs.headerCont.isMobileMenuOpen = false;
			}
		},
		handleResize () {
			// 刷新页面逻辑
      window.location.reload();
		},
		checkMobile() {
			const ua = navigator.userAgent
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
		},
		navToLink(title) {
			this.title = title;
		},
		openCookies() {
			console.log('openCookies');
			this.cookiesTipsOpen = false;
			this.cookiesOpen = true;
		},
		closeTips(){
			localStorage.setItem('isShowMobileOfficialWebsiteAlert', new Date().getTime());
			this.cookiesTipsOpen = false;
		},
		close() {
			this.cookiesOpen = false;
		}

	},
	beforeCreate () {
		// 监听子页面发回来的事件
		bus.$on('inquiry-form', val => {
			this.formOpen = val !== undefined ? val : !this.formOpen
		})
	},
	beforeDestroy() {
		bus.$off('inquiry-form')   // 记得解绑
	},
}
</script>

<style>
@import 'components/common.css';

body {
	margin: 0;
	padding: 0;
	font-family: "Source Han Sans CN", "思源黑体", sans-serif!important;
}

#app {
	/* font-family: Avenir, Helvetica, Arial, sans-serif; */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

.app {
	width: 100%;
	height: 100%;
	position: relative;
}

.header {
	width: 100%;
	height: 5vw;
	background-color: #D5DCC8;
}

.content {
	width: 100%;
	height: 100%;
	position: relative;
}


.bottom {
	width: 100%;
	/* height: 550px; */
	background-color: #F8F9FC;
}

@media (max-width:1700px) {
	/* .header {
		height: 100px;
	} */
}

@media (max-width:1028px) {
	/* .header {
		height: 80px;
	} */
}
@media (max-width:991px) { 
	.header{
    height: 9vh;
  }
}
/* @media (max-width:630px) { 
	.header {
		height: 6vw;
	}
}
@media (max-width:500px) { 
	.header {
		height: 7vw;
	}
}
@media (max-width:410px) { 
	.header {
		height: 8vw;
	}
}
@media (max-width:340px) { 
	.header {
		height:10vw;
	}
} */
</style>
